import { useMutation, useQuery } from "react-query";
import { normalFetch } from "../../fetch-api/get";
import { putApi } from "../../fetch-api/put";
import { useQueryContext } from "../../../contexts/query";


export const packageKeys = {
    getPackages: 'getPackages',
    setPackage: 'setPackage',
}

export const useGetPackages = () => {

    return useQuery(
        packageKeys.getPackages, () => normalFetch('settings/package'),
        {
            select: res => res?.data?.data
        }
    )
}

export const useAddPackage = (onSuccess = () => { }, type) => {

    const { queryClient, setToast } = useQueryContext()

    return useMutation(
        packageKeys.setPackage, (payload) => putApi(payload, 'settings/package'),
        {
            onSuccess: () => {
                setToast({ message: `package-${type}-success`, show: true })
                queryClient.invalidateQueries([packageKeys.getPackages])
                onSuccess()
            }
        }
    )
}

